import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useOperationGetByIdQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseOperationEntity } from 'api/helpers/operation';

export const useOperationGetById = (id: string) => {
  const {
    data,
    loading,
    error: apolloError,
  } = useOperationGetByIdQuery({
    variables: {
      id,
    },
  });

  const error = useError(apolloError);

  const operation = useMemo(() => {
    if (!data?.operation) {
      return null;
    }

    return parseOperationEntity(data.operation);
  }, [data]);

  return {
    operation,
    loading,
    error,
  };
};
